import env from "./env";

const originalFetch = window.fetch.bind(window);

// Any 401 on an authenticated API call means the session is gone.
window.fetch = async (input, init) => {
  const response = await originalFetch(input, init);
  const url = typeof input === "string" ? input : input?.url;
  const headers = new Headers(init?.headers || (typeof input === "object" ? input.headers : undefined));

  if (response.status === 401 && url?.startsWith(env.url) && headers.has("Authorization")) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    if (!["/login", "/signup"].includes(window.location.pathname)) {
      window.location.replace("/login");
    }
  }
  return response;
};
